import httpService from "..";

export const getReportsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/report`,
    "get"
  );
};

export const getEmbedConfigApi = async (
  reportId?: string,
  datasetId?: string,
  groupId?: string | number
) => {
  const params = new URLSearchParams();
  if (reportId) params.set("reportId", reportId);
  if (datasetId) params.set("datasetId", datasetId);
  if (groupId !== undefined && groupId !== null && groupId !== "") {
    params.set("groupId", String(groupId));
  }
  const query = params.toString() ? `?${params.toString()}` : "";
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/powerbi/embed-config${query}`,
    "get"
  );
};
